// extracted by mini-css-extract-plugin
module.exports = {"leftMenu":"styles_leftMenu__118D7","rightPane":"styles_rightPane__re2SI","section":"styles_section__48Quc"};